import createSubtitleFabric from "../../../general/CoreHeader/components/Subtitle/subtitleFabric";
import { createDisplayNameForHeaderSchevron } from "../../utils/createDisplayName";
import { createTestIdForHeaderSchevron } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderSchevron("Subtitle");
const testId = createTestIdForHeaderSchevron("subtitle");

const HeaderSchevronSubtitle = createSubtitleFabric(displayName, testId);

export default HeaderSchevronSubtitle;
